module.exports = __webpack_public_path__ + "img/reminder.c31fcd43.svg";